var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';
import PropTypes from 'prop-types';
import style from './ImageViewer.scss';
import Tooltip from '../Tooltip';
import Trash3 from '../Icons/dist/components/Trash3';
import Replace from '../Icons/dist/components/Replace';
import Plus2 from '../Icons/dist/components/Plus2';
import WixComponent from '../BaseComponents/WixComponent';

var ImageViewer = function (_WixComponent) {
  _inherits(ImageViewer, _WixComponent);

  function ImageViewer() {
    _classCallCheck(this, ImageViewer);

    return _possibleConstructorReturn(this, (ImageViewer.__proto__ || Object.getPrototypeOf(ImageViewer)).apply(this, arguments));
  }

  _createClass(ImageViewer, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          imageUrl = _props.imageUrl,
          onAddImage = _props.onAddImage,
          onUpdateImage = _props.onUpdateImage,
          onRemoveImage = _props.onRemoveImage;


      var tooltipCommonProps = {
        showDelay: 0,
        hideDelay: 0,
        align: 'center',
        placement: 'top',
        moveBy: { x: 2, y: 0 }
      };

      return React.createElement(
        'div',
        { className: style.container + ' ' + (imageUrl && style.hasLogo) },
        React.createElement(
          'div',
          { 'data-hook': 'add-image', className: style.addLogo, onClick: onAddImage },
          React.createElement('div', { className: style.dashedBorder }),
          React.createElement(
            'div',
            { className: style.plusIcon },
            React.createElement(Plus2, { size: '47px' })
          )
        ),
        !!imageUrl && React.createElement(
          'div',
          { className: style.changeLogoContainer },
          React.createElement(
            'div',
            { className: style.imageLayout },
            React.createElement('img', { 'data-hook': 'image-viewer-image', className: style.image, src: imageUrl })
          ),
          React.createElement(
            'div',
            { className: style.imageBackground },
            React.createElement(
              'div',
              { className: style.buttons },
              React.createElement(
                Tooltip,
                _extends({ content: 'Replace' }, tooltipCommonProps),
                React.createElement(
                  'div',
                  { 'data-hook': 'update-image', className: style.button, onClick: onUpdateImage },
                  React.createElement(Replace, { size: '1.2em' })
                )
              ),
              React.createElement(
                Tooltip,
                _extends({ content: 'Remove' }, tooltipCommonProps),
                React.createElement(
                  'div',
                  { 'data-hook': 'remove-image', className: style.button, onClick: onRemoveImage },
                  React.createElement(Trash3, { size: '1.2em' })
                )
              )
            )
          )
        )
      );
    }
  }]);

  return ImageViewer;
}(WixComponent);

ImageViewer.propTypes = {
  imageUrl: PropTypes.string,
  onAddImage: PropTypes.func,
  onUpdateImage: PropTypes.func,
  onRemoveImage: PropTypes.func
};

export default ImageViewer;
//# sourceMappingURL=ImageViewer.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/ImageViewer/ImageViewer.js